// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"2099d84e","538":"e28708fb","599":"c3e11219","724":"818d2535","787":"3d19b9c6","874":"4cbf206e"}[chunkId] + ".chunk.js";
};